// src/router/admin/settings.ts
import type { RouteRecordRaw } from 'vue-router'
import { ROLE_GROUPS } from '../../constants/roleGroups' 

export const adminSettingsRoutes: RouteRecordRaw[] = [
  { 
    path: 'settings/question-bank', 
    name: 'admin.settings.question_bank', 
    component: () => import('../../views/admin/settings/QuestionBankSettingsView.vue'), 
    meta: { title: 'Question Bank Settings', requiresAuth: true, requireRoles: ROLE_GROUPS.ADMINS } 
  },
  {
    path: 'settings/classification',
    name: 'admin.settings.classification',
    component: () => import('../../views/admin/settings/ClassificationView.vue'),
    meta: {title: 'Classifications', requiresAuth: true, requireRoles: ROLE_GROUPS.ADMINS },
  },
  {
    path: 'settings/exams',
    name: 'admin.settings.exams',
    component: () => import('../../views/admin/settings/ExamSettingsView.vue'),
    meta: {title: 'Exam Settings', requiresAuth: true, requireRoles: ROLE_GROUPS.ADMINS },
  },
  {
    path: 'settings/users',
    name: 'admin.settings.users',
    component: () => import('../../views/admin/settings/UsersSettingsView.vue'),
    meta: {title: 'Users Settings', requiresAuth: true, requireRoles: ROLE_GROUPS.SUPER_ADMIN },
  },
  {
    path: 'settings/community',
    name: 'admin.settings.community',
    component: () => import('../../views/admin/settings/CommunitySettingsView.vue'),
    meta: {title: 'Community Settings', requiresAuth: true, requireRoles: ROLE_GROUPS.ADMINS },
  },
  {
    path: 'settings/branding',
    name: 'admin.settings.branding',
    component: () => import('../../views/admin/settings/BrandingSettingsView.vue'),
    meta: {title: 'Branding', requiresAuth: true, requireRoles: ROLE_GROUPS.SUPER_ADMIN },
  },


]
